import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthConfig, OAuthService} from 'angular-oauth2-oidc';

import {DEFAULT_INTERRUPTSOURCES, Idle} from '@ng-idle/core';
import {WarnLogoutComponent} from '../warn-logout/warn-logout.component';
import {Dialog} from '@angular/cdk/dialog';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {safeReturnPath} from '../../services/return-path';

/**
 * Local development only (`ng serve`, environment.localDev): seconds of inactivity before the warning,
 * from localStorage, so the auto-logout can be tried in minutes; it also enables the idle watch on
 * localhost, where it is off otherwise. Deployed builds ignore it.
 */
const DEV_IDLE_SECONDS_KEY = 'dev-idle-seconds';

function devIdleSeconds(): number | null {
  if (!environment.localDev) return null;
  const n = Number(localStorage.getItem(DEV_IDLE_SECONDS_KEY));
  return Number.isFinite(n) && n > 0 ? n : null;
}

@Component({
  selector: 'app-auto-logout',
  template: '',
  styleUrls: []
})
export class AutoLogoutComponent implements OnInit, OnDestroy {

  constructor(private oauthService: OAuthService,
              private dialog: Dialog,
              router: Router,
              private idle: Idle) {
    this.idle.setIdle(devIdleSeconds() ?? 14 * 60 + 30); // 14m30s
    this.idle.setTimeout(10); // 30s
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);


    this.idle.onIdleStart.subscribe(() => {
      this.dialog.open(WarnLogoutComponent)
    });
    this.idle.onTimeout.subscribe(() => {
      // Back to this page after the next login (VTK-3611): the IdP logout returns to the bare origin, so
      // the page goes along as the logout URL's fragment. No server sees a fragment, and every redirect
      // of the chain (oauth-proxy, Cognito) answers without one, so the browser keeps it to the end; the
      // login page then starts its sign-in from that address bar. Only a route of this app.
      const route = safeReturnPath(router.url);
      const config = (this.oauthService as unknown as {config?: AuthConfig}).config;
      const open = config?.openUri;
      if (route && config && open) {
        config.openUri = uri => open(uri.split('#')[0] + '#' + route);
      }
      try {
        this.oauthService.logOut({
          client_id: this.oauthService.clientId,
          logout_uri: this.oauthService.redirectUri,
        });
      } finally {
        if (config && open) config.openUri = open;
      }
    });
  }

  ngOnInit(): void {
    if (window.location.hostname !== 'localhost' || devIdleSeconds() !== null) {
      this.idle.watch();
    }
  }

  ngOnDestroy(): void {
    this.idle.stop();
  }

}
